<template>
  <auth-container>
    <form
      class="max-w-xs bg-white p-6 rounded"
      @submit.prevent="signup">
      <h2 class="text-2xl mb-6">Sign up</h2>

      <p class="text-sm mb-6">Already have an account? <router-link
                                                         class="inline-block align-baseline text-sm text-full-blue"
                                                         :to="{name: 'login', query: {
                                                           redirectFrom: $route.query.redirectFrom}}">Login.</router-link>
      </p>

      </div>


      <p class="text-red text-sm italic my-4" v-if="error">
        {{error}}
      </p>
      <p class="text-red text-sm italic my-4" v-if="localError">
        {{localError}}
      </p>
      <div class="mb-4">
        <label class="block text-sm font-bold pb-2" for="username">
          Your Email Address
        </label>
        <input
          class="appearance-none border-gray-light border rounded w-full py-2 px-3 text-sm text-grey-darker leading-tight focus:outline-none focus:shadow-outline tracking-wide"x
          id="username"
          name="username"
          v-model="email"
          type="text"
          placeholder="Email Address">
      </div>
      <div class="mb-4">
        <label class="block text-sm font-bold pb-2" for="password">
          Password
        </label>
        <input
          class="appearance-none border-gray-light border rounded w-full py-2 px-3 text-sm mb-3 focus:outline-none focus:shadow-outline"
          id="password"
          type="password"
          name="password"
          v-model="password"
          placeholder="******************">
      </div>


      <div class="mb-6">
        <label class="block text-sm font-bold pb-2" for="password">
          Confirm Password
        </label>
        <input
          class="appearance-none border-gray-light border rounded w-full py-2 px-3 text-sm mb-3 focus:outline-none focus:shadow-outline"
          id="confirm-password"
          type="password"
          name="confirm-password"
          v-model="confirmPassword"
          placeholder="******************">
      </div>

      <div class="flex items-center justify-end">
        <button
          class="bg-full-blue ml-4 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline text-sm"
          type="submit"
        >
          Sign up
        </button>
      </div>
    </form>
  </auth-container>
</template>


<script>
 import {mapState, mapGetters} from 'vuex';
 import AuthContainer from '@/components/AuthContainer';

 export default {
   data() {
     return {
       email: '',
       password: '',
       confirmPassword: '',
       localError: ''
     }
   },
   components: {AuthContainer},
   computed: Object.assign(mapGetters(['isLoggedIn']), mapState({
     error: state => state.signupError
   })),

   created () {
     this.$store.commit('clearErrors');


     if (this.isLoggedIn) {
       this.$router.replace(this.$route.query.redirectFrom || '/');
     }
   },

   methods: {
     async signup () {
       if (this.password !== this.confirmPassword) {
         this.localError = 'Passwords do not match';
         return;
       }

       this.localError = '';

       const res = await this.$store.dispatch('signup', {
         email: this.email,
         pw: this.password
       });

       if (res !== false) {
         this.$router.replace({
           name: 'verify-email',
           query: {
             last: 'signup',
             redirectFrom: this.$route.query.redirectFrom
           }
         });
       }
     }
   }
 }
</script>
